import { render, staticRenderFns } from "./MiniItem.vue?vue&type=template&id=1516607b&scoped=true&"
import script from "./MiniItem.vue?vue&type=script&lang=js&"
export * from "./MiniItem.vue?vue&type=script&lang=js&"
import style0 from "./MiniItem.vue?vue&type=style&index=0&id=1516607b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1516607b",
  null
  
)

export default component.exports